export default '/@lang/assistant'
